import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status, error, retry, signOut } = useAuth();
  if (status === 'loading') {
    return (
      <main className="flex min-h-screen items-center justify-center bg-page text-fg-muted">
        <p className="text-sm">Loading…</p>
      </main>
    );
  }
  // A bootstrap that failed for any reason other than 401. This branch is the
  // whole point of the 'error' state: previously the app sat on "Loading…"
  // indefinitely with no explanation and no way out.
  if (status === 'error') {
    return (
      <main className="flex min-h-screen items-center justify-center bg-page">
        <div style={{ maxWidth: 420, textAlign: 'center', padding: 24 }}>
          <h1
            style={{
              fontFamily: 'var(--serif)',
              fontSize: 20,
              color: 'var(--ink)',
              margin: '0 0 8px',
            }}
          >
            Couldn&apos;t sign you in
          </h1>
          <p style={{ fontSize: 13, lineHeight: 1.45, color: 'var(--ink-2)', margin: '0 0 16px' }}>
            {error ?? 'Something went wrong. Try again.'}
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
            {/* Escape hatch: if retrying keeps failing (no_project_access never
                resolves itself), signing out gets back to the login screen. */}
            <button type="button" className="btn btn-ghost" onClick={() => void signOut()}>
              Sign out
            </button>
            <button type="button" className="btn btn-cta" onClick={retry}>
              Retry
            </button>
          </div>
        </div>
      </main>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
